export const SET_NAV_DATA = 'SET_NAV_DATA';
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_PLAN_DATA = 'SET_PLAN_DATA';
export const USER_LOG_OUT = 'USER_LOG_OUT';
export const SET_CHECK_USAGE = 'SET_CHECK_USAGE';
export const SET_USAGE = 'SET_USAGE';
export const SET_HEADER_TITLE = 'SET_HEADER_TITLE';
